import { Link } from 'react-router-dom';
import { postListFetcher } from '@/shared/api/list';
import { formatUnixDateTime } from '@/shared/lib/datetime';
import { DeleteButton } from '@/shared/ui/list/DeleteButton';
import { GenericListPage } from '@/shared/ui/list/GenericListPage';
import type { ListPageConfig, ListRow } from '@/shared/ui/list/types';
import { deleteArticle, fetchCategoryOptions } from './api';

const LIST_KEY = 'publications-articles';

interface Article extends ListRow {
  id: number;
  title?: string;
  teaser?: string;
  created_time?: number | string;
  status_id?: number | string;
  count_view?: number | string;
  category?: { title?: string } | null;
  user?: { name?: string } | null;
}

const stripTags = (html = '') => html.replace(/<[^>]*>/g, '');

const editPath = (id: number) => `/publications/article/edit/${id}`;

const config: ListPageConfig<Article> = {
  queryKey: LIST_KEY,
  title: 'Новости и статьи',
  boxTitle: 'Список новостей и статей',
  errorText: 'Ошибка загрузки статей',
  fetchList: postListFetcher('/publication/article/index/'),
  rows: ['items'],
  sortStyle: 'signed',
  searchKeys: [
    { value: 'filter[id]', label: 'Поиск по id' },
    { value: 'filter[user_id]', label: 'Поиск по id пользователя' },
    { value: 'filter[title]', label: 'Поиск по заголовку' },
    { value: 'filter[body]', label: 'Поиск по тексту в статье' },
  ],
  filters: [
    {
      name: 'filter[category_id]',
      label: 'Фильтрация по категории',
      kind: 'select',
      loadOptions: fetchCategoryOptions,
    },
    { name: 'filter[published_from]', label: 'Опубликовано с', kind: 'datetime' },
    { name: 'filter[published_to]', label: 'Опубликовано по', kind: 'datetime' },
  ],
  headerActions: (
    <Link to="/publications/article/create" className="btn btn-info pull-right">
      Создать
    </Link>
  ),
  columns: [
    { header: 'id', sortField: 'id', render: (article) => article.id },
    {
      header: 'Заголовок',
      render: (article) => <Link to={editPath(article.id)}>{article.title}</Link>,
    },
    { header: 'Дата создания', render: (article) => formatUnixDateTime(article.created_time) },
    { header: 'Тело', render: (article) => stripTags(article.teaser) },
    {
      header: 'Категория',
      sortField: 'category_id',
      render: (article) => article.category?.title ?? 'No category',
    },
    { header: 'Статус', render: (article) => article.status_id },
    {
      header: 'Пользователь',
      sortField: 'user_id',
      render: (article) => article.user?.name ?? 'No user',
    },
    { header: 'Просмотры', render: (article) => article.count_view },
    {
      header: 'Edit',
      render: (article) => (
        <Link to={editPath(article.id)} className="btn btn-success btn-sm">
          Edit
        </Link>
      ),
    },
    {
      header: 'Удалить',
      render: (article) => (
        <DeleteButton listKey={LIST_KEY} remove={() => deleteArticle(article.id)} />
      ),
    },
  ],
};

export const ArticlesPage = () => <GenericListPage config={config} />;
